import AxiosLogo from '../assets/AxiosBlack'

const axios = {
  getImage: (props) => <AxiosLogo className="axios" {...props} />,
  getURL: (variant) =>
    'https://www.axios.com/newsletters/axios-pro-rata-943c05ac-f87b-4700-bb8d-1520f75a8b2e.html?utm_source=newsletter&utm_medium=email&utm_campaign=newsletter_axiosprorata&stream=top',
}

export default axios
